import React from 'react';
import { useTeams } from '../contexts/TeamsContext';
import { Team } from 'api-client';
import { showToast } from '../lib/toast';


const TeamSwitcher: React.FC = () => {
  const { teams, currentTeam, switchTeam, isLoading, error } = useTeams();

  if (isLoading) {
    return (
      <div className="flex items-center justify-center p-8">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500"></div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="p-4 bg-red-50 border border-red-200 rounded-lg">
        <p className="text-red-600">{error}</p>
      </div>
    );
  }

  return (
    <div className="p-4 max-w-2xl mx-auto">
      <h1 className="text-2xl font-bold mb-6">Switch Team</h1>
      
      {/* Current Team Info */}
      {currentTeam && (
        <div className="mb-6 p-4 bg-blue-50 rounded-lg border border-blue-200">
          <h2 className="font-semibold text-lg mb-2">Current Team</h2>
          <div className="space-y-1">
            <p className="text-gray-700">
              <span className="font-medium">Name:</span> {currentTeam.name}
            </p>
            {currentTeam.slug && (
              <p className="text-gray-700">
                <span className="font-medium">Slug:</span> {currentTeam.slug}
              </p>
            )}
            {currentTeam.isAdmin && (
              <p className="text-green-600 text-sm font-medium">Admin Access</p>
            )}
          </div>
        </div>
      )}



      {/* Teams List */}
      <div className="space-y-3">
        <h2 className="font-semibold text-lg">Available Teams</h2>
        {teams.map((team) => (
          <div
            key={team.id}
            className={`p-4 rounded-lg cursor-pointer transition-all ${team.id === currentTeam?.id
              ? 'bg-blue-100 border-2 border-blue-500 shadow-sm'
              : 'bg-white hover:bg-gray-50 border border-gray-200 hover:border-blue-300 hover:shadow-sm'}`}
            onClick={() => {
              switchTeam(team);
              showToast.success('Team changed successfully!');
            }}
          >
            <div className="flex items-start justify-between">
              <div>
                <h3 className="font-medium text-gray-900">{team.name}</h3>
                {team.slug && (
                  <p className="text-sm text-gray-500">Slug: {team.slug}</p>
                )}
              </div>
              {team.isAdmin && (
                <span className="px-2 py-1 text-xs font-medium text-green-700 bg-green-100 rounded-full">
                  Admin
                </span>
              )}
            </div>
          </div>
        ))}

        {teams.length === 0 && (
          <p className="text-gray-500 text-center py-4">
            No teams available. Please contact your administrator to get access to a team.
          </p>
        )}
      </div>
    </div>
  );
};

export default TeamSwitcher;
